import { SVLabeledText } from '@/components/core';
import {
  BankAccountApplicationRequirementType,
  BankApplicationRequirements,
  RequirementStatus,
} from '@/types/bankApplications';
import { formatDateTimeFromUTC } from '@/utils/date';
import { Box, Card, Grid, Stack, Typography } from '@mui/material';

type BankApplicationRequirementsProps = {
  requirements: BankApplicationRequirements[];
};

export default function BankApplicationRequirementsCard({
  requirements,
}: BankApplicationRequirementsProps) {
  if (requirements.length < 1) {
    return null;
  }

  return (
    <Card sx={{ p: 3 }}>
      <Typography variant="h5" mb={3}>
        Requirements
      </Typography>
      <Grid container spacing={3}>
        {requirements.map(requirement => (
          <Grid size={{ xs: 12, md: 6, lg: 4, xl: 3 }} key={requirement.uuid}>
            <Box
              sx={{
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 1,
                p: 2,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
              }}>
              <Stack spacing={2}>
                <SVLabeledText
                  label="Status"
                  text={
                    requirement.status === RequirementStatus.COMPLETED
                      ? 'Completed'
                      : requirement.status === RequirementStatus.PENDING
                        ? 'Pending'
                        : 'Started'
                  }
                />
                <SVLabeledText
                  label="Type"
                  text={
                    requirement.type ===
                    BankAccountApplicationRequirementType.digital_signature_requirement
                      ? 'Digital Signature'
                      : requirement.type ===
                          BankAccountApplicationRequirementType.kyc_evaluation_requirement
                        ? 'KYC Evaluation'
                        : requirement.type ===
                            BankAccountApplicationRequirementType.submit_to_third_party_requirement
                          ? 'Submit to Third Party'
                          : 'Person Application'
                  }
                />
                <SVLabeledText
                  label="Priority"
                  text={requirement.priority.toString()}
                />
                <SVLabeledText
                  label="Started At"
                  text={formatDateTimeFromUTC(requirement.startedAt)}
                />
                <SVLabeledText
                  label="Generated At"
                  text={formatDateTimeFromUTC(requirement.generatedAt)}
                />
                {requirement.completedAt && (
                  <SVLabeledText
                    label="Completed At"
                    text={formatDateTimeFromUTC(requirement.completedAt)}
                  />
                )}
                {requirement.failedAt && (
                  <SVLabeledText
                    label="Failed At"
                    text={formatDateTimeFromUTC(requirement.failedAt)}
                  />
                )}
                {requirement.errorMessage && (
                  <SVLabeledText
                    label="Error Message"
                    text={requirement.errorMessage}
                  />
                )}
              </Stack>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Card>
  );
}
